import React from 'react';
import SelectWidget from "react-jsonschema-form/lib/components/widgets/SelectWidget";
import TextWidget from "react-jsonschema-form/lib/components/widgets/TextWidget";
import {toErrorList} from "react-jsonschema-form/lib/validate"
import {asNumber} from "react-jsonschema-form/lib/utils";
import {Label} from "./ValmetFieldTemplate"

function ErrorList(props) {
  const {errors = []} = props;
  if (errors.length === 0) {
    return <div/>;
  }
  return (
    <div className="errors">
      <p/>
      <ul className="error-detail bs-callout bs-callout-info">{
        errors.map((error, index) => {
          return <li className="text-danger" key={index}>{error.stack}</li>;
        })
      }</ul>
    </div>
  );
}


class ValueWithUnit extends React.Component {

  options(enums, enumNames) {
    let options = [];
    enums.forEach((val, i) => options.push({value: val, label: enumNames[i]}))
    return options;
  }

  constructor(props) {
    super(props);
    // we use internal value to show f.ex. 5.0 to user without error when he enters it.
    // workaround to problem where 5.0 type value is automagically converted to 5 ( .0 part is removed) 
    // when it is wrapped in json.
    this.state = {...props.formData, internalValue: props.formData.value};
    // this.state = {...props.formData};
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps.formData});
  }

  getAsNumber(value) {
    if (value === "") {
      return undefined;
    }
    if (/\.$/.test(value)) {
      // "3." can't really be considered a number even if it parses in js. The
      // user is most likely entering a float.
      return value;
    }
    var n = Number(value);
    var valid = typeof n === "number" && !Number.isNaN(n);
    return valid ? n : value;
  }
  
  onChange(name) {
    return (event) => {
      // we use internal value to show f.ex. 5.0 to user without error when he enters it.
      // workaround to problem where 5.0 type value is automagically converted to 5 (and .0 part is removed) 
      // when it is wrapped in json.
      this.setState({
        "internalValue": event
      });
      this.setState({
        "value": this.getAsNumber(event)
      }, () => this.props.onChange(this.state));
    };
  }

  onChangeUnit(name) {
    return (event) => {
      this.setState({
        "unit": asNumber(event)
      }, () => this.props.onChange(this.state));
    };
  }


  render() {
    const errorList = toErrorList(this.props.errorSchema) || [];
    const {title, type, description} = this.props.schema;
    const {value, internalValue, unit} = this.state;
    const enums = this.props.schema.properties.unit.enum;
    const enumNames = this.props.schema.properties.unit.enumNames;
    const enumOptions = {enumOptions: this.options(enums, enumNames)};
    const required = this.props.schema.properties.required || false;
    const idValue = this.props.idSchema.$id + "_value";
    const idUnit = this.props.idSchema.$id + "_unit";
    const {disabled, readonly, autofocus} = this.props;
    const unitSchema = this.props.schema.properties.unit;
    const uiSchema = this.props.uiSchema;
    const label = title;
    const id = idValue;
    const displayLabel = true;

    const classNames = [
      "form-group",
      "field",
      `field-${type}`,
      errorList.length > 0 ? "field-error has-error" : "",
      uiSchema.classNames,
    ].join(" ").trim();

    return (
      <div className={classNames}>
        <ul className="list-inline">
          <li>
            <TextWidget
              id={idValue}
              value={internalValue}
              disabled={disabled}
              readonly={readonly}
              autofocus={autofocus}
              onChange={this.onChange("value")}
              />
          </li>
          <li>
            <SelectWidget
              schema={unitSchema}
              id={idUnit}
              className="form-control"
              options={enumOptions}
              value={unit}
              disabled={disabled}
              readonly={readonly}
              autofocus={autofocus}
              onChange={this.onChangeUnit("unit")}/>
          </li>
        </ul>
        <ErrorList errors={errorList}/>
      </div>
    );
  }
}

export default ValueWithUnit;


// WEBPACK FOOTER //
// ./src/components/ValueWithUnit.js